module.exports = __webpack_public_path__ + "img/login-img1-origin.359a54d8.png";